import { createTheme } from '@mui/material/styles';

// NextZenOlympiad Brand Colors - Single Source of Truth
export const brandColors = {
  primary: '#5b21b6',     // Deep purple from branding gradient
  secondary: '#7c3aed',   // Mid purple from branding gradient  
  accent: '#8b5cf6',      // Light purple from branding gradient
  primaryHover: '#4c1d95', // Darker purple for hover states
  white: '#ffffff',
  textSecondary: 'rgba(255, 255, 255, 0.8)',
};

const theme = createTheme({
  palette: {
    primary: {
      main: brandColors.primary,
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.secondary,
      contrastText: brandColors.white,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          background: `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.secondary} 50%, ${brandColors.accent} 100%)`,
          color: brandColors.white,
          border: 'none',
          boxShadow: '0 4px 12px rgba(91, 33, 182, 0.3)',
          '&:hover': {
            background: `linear-gradient(135deg, ${brandColors.primaryHover} 0%, ${brandColors.primary} 50%, ${brandColors.secondary} 100%)`,
            boxShadow: '0 6px 16px rgba(91, 33, 182, 0.4)',
          },
          '&:disabled': {
            background: '#ccc',
            color: brandColors.white,
            boxShadow: 'none',
          },
        },
        outlined: {
          borderColor: brandColors.primary,
          color: brandColors.primary,
          '&:hover': {
            borderColor: brandColors.primaryHover,
            backgroundColor: 'rgba(91, 33, 182, 0.04)',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        },
      },
    },
    // Mobile-specific improvements
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            // Ensure proper touch target size on mobile
            minHeight: '48px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // Improve touch interactions on mobile
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    },
  },
  // Mobile-specific breakpoints
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;